import { getSeedRandom } from '../../utils';
import { getSystemUniqueId } from './system-unique-id';
import { MAXSIZE } from '../../data/constants';
import { pipe } from 'rxjs';
import memoize from 'fast-memoize';

export const getSystemSize = memoize(
  pipe(getSystemUniqueId, getSeedRandom, (rand) => rand(0, MAXSIZE - 1)),
);
